import { jsx, jsxs } from "react/jsx-runtime";
import { Tabs } from "@base-ui/react/tabs";
import { useCallback } from "react";
import { cn } from "../../utils/index.js";
import { PanelTabs } from "./PanelTabs.js";
import { PanelTabsHeader } from "./PanelTabsHeader.js";
import { tabsVariants } from "./Tabs.variants.js";
function Tabs_Tabs({ slotClassNames = {}, defaultValue, value: parentControlledValue, emphasis = 'regular', stacked = false, bleed, tabsContent, onValueChange, 'aria-label': ariaLabel }) {
    const { root, list, indicator, panel } = tabsVariants({
        emphasis,
        stacked,
        bleed
    });
    const { rootClass = '', listClass = '', tabClass = '', indicatorClass = '', panelClass = '', iconClass = '', tabLabelContentClass = '' } = slotClassNames;
    const rootClasses = cn(root(), rootClass);
    const listClasses = cn(list(), listClass);
    const indicatorClasses = cn(indicator(), indicatorClass);
    const panelClasses = cn(panel(), panelClass);
    const onValueChangeCallback = useCallback((newValue, eventDetails)=>{
        if ('none' !== eventDetails.reason) return;
        onValueChange?.(newValue, eventDetails.event);
    }, [
        onValueChange
    ]);
    return /*#__PURE__*/ jsxs(Tabs.Root, {
        className: rootClasses,
        defaultValue: defaultValue,
        value: parentControlledValue,
        onValueChange: onValueChangeCallback,
        children: [
            /*#__PURE__*/ jsxs(Tabs.List, {
                activateOnFocus: false,
                "aria-label": ariaLabel,
                className: listClasses,
                children: [
                    /*#__PURE__*/ jsx(PanelTabsHeader, {
                        tabsContent: tabsContent,
                        tabClass: tabClass,
                        iconClass: iconClass,
                        tabLabelContentClass: tabLabelContentClass,
                        emphasis: emphasis,
                        stacked: stacked
                    }, `header-${tabsContent.length}`),
                    /*#__PURE__*/ jsx(Tabs.Indicator, {
                        className: indicatorClasses
                    })
                ]
            }),
            /*#__PURE__*/ jsx(PanelTabs, {
                tabsContent: tabsContent,
                panelClasses: panelClasses
            })
        ]
    });
}
export { Tabs_Tabs as Tabs };
